import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const List = styled.ul`
  margin: 0;
  padding: 0;
`;

// const defaultRule = () => true;

class FilterList extends Component {
  static propTypes = {
    activeFilter: PropTypes.object,
    items: PropTypes.array,
    renderItem: PropTypes.func,
    filterFunc: PropTypes.func,
  }
  static defaultProps = {
    items: [],
    renderItem: () => {},
    filterFunc: () => {},
    rules: {},
  }
  render() {
    const {
      activeFilter,
      items,
      renderItem,
      filterFunc,
    } = this.props;
    return (
      <List>
        {
          items.map((item, i) => renderItem(item.id, i, filterFunc(activeFilter)(item)))
        }
      </List>
    );
  }
}

export default FilterList;



// WEBPACK FOOTER //
// ./src/components/organisms/FilterList/index.js